<section class="benefits-section">
    <div class="container">
        <div class="section-header benefits-header">
            <div class="benefits-title">
                <h2 class="section-title">Mis beneficios</h2>
                <span class="benefits-promo">{{ descuentoGlobal }}</span>
            </div>
            <a class="section-link" (click)="verTodosLosServicios()">Ver todos los servicios</a>
        </div>
        <p class="benefits-sub">{{ subtitulo }}</p>

        <div class="benefits-grid">
            <div class="benefit-card" *ngFor="let beneficio of items; let i = index">
                <div class="benefit-top">
                    <span class="benefit-discount">{{ beneficio.descuento }}</span>
                    <img class="benefit-icon" [src]="iconForBenefit(beneficio, i)" alt="" aria-hidden="true">
                </div>
                <div class="benefit-body">
                    <h3 class="benefit-title">{{ beneficio.titulo }}</h3>
                    <p class="benefit-desc">{{ beneficio.desc }}</p>
                    <a class="benefit-link" (click)="verBeneficio(beneficio)">
                        <span>Descubre más</span>
                        <svg class="benefit-arrow" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                            <line x1="4" y1="10" x2="16" y2="10"/>
                            <polyline points="11 5 16 10 11 15"/>
                        </svg>
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>
